<template>
  <div class="login-card">
    <asset-v3  class="searchIcon" :dir="dir" :name="icon" />
    <h1>
      Ops! Página não encontrada
    </h1>
    <p class="lead">
      A página que você acessou não existe ou foi removida.
    </p>
    <button @click="rollBack" class="login-button">
      Voltar para a página inicial
    </button>
  </div>
</template>

<script>

// import AppButton from './AppButton.vue';
import AssetV3 from '../common/AssetV3.vue';

export default {
  name: 'NotFoundCard',
  components: {
    // AppButton,
    AssetV3,
  },
  data() {
    return {
      dir: 'icons',
      icon: 'outline-search-circle.png',
    };
  },
  methods: {
    rollBack() {
      this.$router.push({ path: '/' });
    },
  },
};

</script>

<style lang="scss" scoped>
  h1 {
    line-height: 2.5rem;
    font-size: 2rem;
    margin-bottom: .75rem;
  }

  .login-card {
    background-color: white;
    width: 100%;
    max-width: 420px;
    border-radius: 1.5rem;
    padding: 24px;
    box-shadow: var(--shadow-elevation-high);

    @media (min-width: $md) {
      margin-top: 56px; //altura do footer
      padding: 36px;
    }
  }

  .login-button {
    display: flex;
    padding: 0 1.5rem;
    justify-content: center;
    align-items: center;
    line-height: 1.5rem;
    font-weight: 600;
    cursor: pointer;
    width: 100%;
    color: var(--white);
    background-color: var(--color-primary);
    border-radius: 28px;
    border-color: transparent;
    height: 56px;

    &:hover {
      background-color: var(--color-primary-600) !important;
      border-color: transparent;
    }

    @media (min-width: $md) {
      height: 42px;
      width: auto;
    }
  }

  .lead {
    color: var(--color-gray-500);
    margin-bottom: 1.25rem;
  }

  .icon-background {
    display: flex;
    justify-content: center;
    align-items: center;
    width:48px;
    height: 48px;
    border-radius: 100%;
  }

  .searchIcon{
    background-color: var(--blue-200);
    border-radius: 50%;
    height: 24px;
    width: 24px;
    padding: 12px;
  }
</style>
